import React from 'react'
import LocationFinderView from './locationFinderView'

export default class LocationFinderContainer extends React.Component {
    render() {
        return (
            <LocationFinderView
                back_press_callback={this.props.back_press_callback}
                on_location_selected={this.props.on_location_selected}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/locationFinder/locationFinderContainer.js